import { render, staticRenderFns } from "./caption-panel.vue?vue&type=template&id=31677800&"
import script from "./caption-panel.vue?vue&type=script&lang=ts&"
export * from "./caption-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports